import React, { useState } from 'react';
import Board from './components/Board';
import ScoreBoard from './components/ScoreBoard';
import Modal from './components/Modal';

function App() {
    const [showScores, setShowScores] = useState(false);
    const [username, setUsername] = useState(null);

    const handleUsernameSubmit = (name) => {
        setUsername(name);
        localStorage.setItem('currentUsername', name);
    };

    if (!username) {
        return <Modal onSubmit={handleUsernameSubmit} />;
    }

    return (
        <div className="game-container">
            {!showScores && <Board onShowScores={() => setShowScores(true)} username={username} />}

            {showScores && <ScoreBoard onBack={() => setShowScores(false)} />}
        </div>
    );
}

export default App;
